import { inject, type InjectionKey, type ComputedRef, type Ref } from 'vue';
import type { paths } from '@/shared/api/autogen/schema';

type AuthUserResponse = paths['/auth/user']['get']['responses']['200']['content']['application/json'];
type User = AuthUserResponse['user'];

export type Role = {
    isAdmin: boolean;
    /** 最上位の管理者のみ（スタッフ管理など at-admin 限定機能の判定用） */
    isAtAdmin: boolean;
    isHotel: boolean;
    isAirport: boolean;
    isSC: boolean;
};

export type UseAuth = {
    user: Ref<User | null>;
    isAuthenticated: ComputedRef<boolean>;
    role: ComputedRef<Role>;
    getAccessToken: () => string | null;
    getRefreshToken: () => string | null;
};

export const AUTH_KEY: InjectionKey<UseAuth> = Symbol('auth');

export const useAuth = (): UseAuth => {
    const auth = inject(AUTH_KEY);
    if (!auth) {
        throw new Error('useAuth requires provideAuth to be called in app layer');
    }

    return auth;
};
